import { Flex, Grid, Modal, Typography } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { CustomButton } from '@/components/ui';
import './index.scss';
import { useNavigate } from 'react-router';
import { ROUTES } from '@/types/routes';
import './index.scss';
import Restricted from '@/assets/images/restricted.png';

interface Props {
  open: boolean;
  onCancel: () => void;
  // TCX-713: optional copy overrides — same design, different words. Defaults
  // preserve the original activate-your-subscription variant, so existing
  // call sites need no changes.
  title?: string;
  description?: string;
  ctaText?: string;
}

/**
 * TCX-713 (Option C): the Connect-restriction variant of this modal. A TCX
 * Connect subscriber keeps seeing the Message / Book-a-Meeting buttons;
 * clicking opens this copy instead of starting the flow. Draft copy pending
 * product/Suzana confirmation — adjust the strings here only. The CTA lands on
 * the subscription page (no upgrade option exists there yet — the
 * Connect→Full upgrade flow is a separate upcoming ticket).
 */
export const CONNECT_RESTRICTED_COPY = {
  title: 'Not Included in Your Plan',
  description:
    "Starting new conversations and booking meetings aren't included in your TCX Connect plan. Upgrade to a full subscription to unlock them. You can still receive and respond to consultant inquiries in Messages.",
  ctaText: 'View My Subscription',
} as const;

export const AccessRestricted = ({
  open,
  onCancel,
  title = 'Action Not Available',
  description = 'Activate your profile to unlock messaging and bookings. You need an active profile to connect with others.',
  ctaText = 'Activate Your Subscription',
}: Props) => {
  const navigate = useNavigate();
  const { lg } = Grid.useBreakpoint();

  return (
    <Modal
      closeIcon={<CloseOutlined />}
      open={open}
      onCancel={onCancel}
      width={460}
      centered
      footer={null}
      className={'access-restricted-modal'}
      styles={{
        mask: {
          backdropFilter: 'blur(10px)',
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
        },
      }}
    >
      <Flex vertical className={'header'} align={'start'}>
        <div style={{ position: 'absolute', top: 10, left: 10 }}>
          <img src={Restricted} alt="restricted" width={lg ? 440 : 395} />
        </div>
        <div style={{ marginTop: '230px' }} />
        <Typography.Text className={'title'}>{title}</Typography.Text>

        <Typography.Text className={'description'}>
          {description}
        </Typography.Text>
      </Flex>

      <Flex vertical gap={12}>
        <CustomButton
          onClick={async () => {
            navigate(ROUTES.MY_PROFILE_SUBSCRIPTION);
            onCancel();
          }}
          type={'primary'}
          text={ctaText}
        />
      </Flex>
    </Modal>
  );
};
